import { FC, useCallback, useContext, useMemo } from "react";
import { renderInputComponent } from "../../../utils";
import { useTabs } from "../../../hooks/useTabs";
import { FormView, SchemaItem } from "@data-root/types";
import { List, ListProps } from "antd";
import { InlineSingleRowProps, useInlineContext } from "@data-root/react";

export const InlineFormFlatPresentation: FC<InlineSingleRowProps> = ({
  loaded,
}) => {
  const { table, view } = useInlineContext();

  const { tabItems: items } = useTabs(table, (view as FormView).itemGroups);

  const flatItems = useMemo(() => items.flat(), [items]);

  const renderFn = useCallback<ListProps<SchemaItem>["renderItem"]>(
    (item, index) => (
      <List.Item>{renderInputComponent({ item, index })}</List.Item>
    ),
    []
  );

  return <List split={false} dataSource={flatItems} renderItem={renderFn} />;
};
